import React, { useState } from 'react';
import './index.css';
import { ApprovalRequest } from '../../../../../redux/AllocationRequest';

interface ApprovalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (notes: string) => void;
  actionType: 'approve' | 'reject' | null;
  request: ApprovalRequest;
}

export const ApprovalModal: React.FC<ApprovalModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  actionType,
  request
}) => {
  const [notes, setNotes] = useState('');

  if (!isOpen) return null;

  const isApprove = actionType === 'approve';
  const title = isApprove ? 'Approve Request' : 'Reject Request';
  const message = isApprove 
    ? 'This request will be approved and can proceed to production planning.'
    : 'This request will be rejected. Please provide a reason.';

  const handleConfirm = () => {
    onConfirm(notes);
    setNotes('');
  };

  const handleClose = () => {
    setNotes('');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close" onClick={handleClose}>×</button>
        </div>
        
        <div className="modal-body">
          <p className="modal-message">{message}</p>
          
          <div className="request-summary">
            <div className="summary-row">
              <span className="summary-label">Target:</span>
              <span className="summary-value">{request.targetDate}</span>
            </div>
            <div className="summary-row">
              <span className="summary-label">Request:</span>
              <span className="summary-value">{request.id}</span>
            </div>
            <div className="summary-row">
              <span className="summary-label">Summary:</span>
              <span className="summary-value">{request.summary}</span>
            </div>
          </div>

          <div className="products-summary">
            <div className="products-title">Products</div>
            <div className="products-list-modal">
              {request.products.map((product, idx) => (
                <div key={idx} className="product-summary-item">
                  <span className={`tier-badge-modal ${product.tier.toLowerCase()}`}>
                    {product.tier}
                  </span>
                  <span className="product-name-modal">{product.name}</span>
                  <span className="product-qty-modal">{product.quantity} packs</span>
                </div>
              ))}
            </div>
          </div>

          <div className="notes-section">
            <label className="notes-label">Notes (Optional)</label>
            <textarea
              className="notes-input"
              placeholder="Add any notes for the requester..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button 
            className={`btn-confirm ${isApprove ? 'btn-confirm-approve' : 'btn-confirm-reject'}`}
            onClick={handleConfirm}
          >
            {isApprove ? 'Confirm Approval' : 'Confirm Rejection'}
          </button>
        </div>
      </div>
    </div>
  );
};